// data.advancedModules.ipr?.options?.iprPosition
export const getStepsWithIpr = (data) => {
    const stepsWithIpr = {};
    const isEndTogether = data.sync === "End together";
    const adjustLesserSide = Math.abs(data.lowerSteps - data.upperSteps);
    const isUpperStepsGreater = data.upperSteps > data.lowerSteps;
    const iprPositions = data?.advanced_modules?.ipr?.options?.iprPosition || data?.advancedModules?.ipr?.options?.iprPosition || {};
    Object.keys(iprPositions).forEach((iprIndex) => {
        Object.entries(iprPositions[iprIndex]).forEach(([step, iprValue]) => {
            if (iprValue) {
                if (isEndTogether) {
                    if (isUpperStepsGreater && iprIndex > 15) {
                        stepsWithIpr[Number(step) + adjustLesserSide] = true;
                    } else if (!isUpperStepsGreater && iprIndex < 15) {
                        stepsWithIpr[Number(step) + adjustLesserSide] = true;
                    } else {
                        stepsWithIpr[step] = true;
                    }
                } else {
                    stepsWithIpr[step] = true;
                }
            }
        });
    });
    return stepsWithIpr;
}

// ObjectShape
const data = {
    "viewerLinkUrl": "https://eon-tp-viewer-coldfix.eonmfg.com?isM=true&treatmentSetupsId=bed10e92f89b479e90497ced2a3a8d60&dn=universal",
    "patientsViewerLinkUrl": "https://eon-tp-viewer-coldfix.eonmfg.com?isM=true&treatmentSetupsId=bed10e92f89b479e90497ced2a3a8d60&dn=universal&isPatient=true",
    "uuid": "bed10e92f89b479e90497ced2a3a8d60",
    "ownerType": "client",
    "eonCaseId": null,
    "eonTsId": null,
    "refinementId": null,
    "title": "Initial 1",
    "identifier": "23068211LJ.ANGU",
    "version": 1,
    "upperSteps": 10,
    "lowerSteps": 10,
    "sync": "Start together",
    "irregularities": "2",
    "severity": "Mild",
    "wearCycle": null,
    "iprSheet": "https://eon-manufacturing-dev.s3.eu-central-1.amazonaws.com/public/eon-mfg/23068211LJ.ANGU/attachedFiles/treatment-summary-pdf-1690216145366?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA2DDTJHHC534KVVMA%2F20230925%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20230925T130346Z&X-Amz-Expires=604800&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEGQaDGV1LWNlbnRyYWwtMSJHMEUCIGpq%2Fq%2FVpG2TxEd7Y8h2qS58v5XZN1IDHLIm4aZoliSsAiEAyTGddT9hPxp0SBmUAgYotTxX0VP0jrsl1x%2FiQ8Tjoa0qygUIXhADGgw2OTM4Nzg5OTUzOTciDPO2lB6%2FQNN5mwTb4SqnBXnAffGEOYSaCVFBB4KTc00hJxzOQbKYAEuPt5yMSPMvrXhnfWYu5iaUtxqwBsE0Xifu3xJCdv8hHD%2BC4kUc6OQAVJtNAeimR755h8uVUo%2Bwi%2BAK0OQ%2BaFADtCfu0iASfpXeyI3w%2BgadpxLDlI%2BAd%2F4cEPM9ehx%2B15TnIwgW0%2BrLyoYeOZyXP52G8aYG0ZPCEOFkvv6xH8L64uylwRCkS3Z01DmnYkN0uF1p1dzW3NCuF0N1pWjYaCdZQqW4HLN609eVsrT10fSAopV8TEV7gkbUaKRVMbRimrlQPRborwsR6YKjjm7dD0r51xo13FfEzVfLxz%2FWrCZeXZ5GQEjScNnLWG8oA6iqGC2rMxadRymt3u2qG92guVHTqI4pzrEAYvZfX47M%2FXIUJ8%2BhZu8rSQYCw1WdcZ8a3OcTZhmF0VeannrY5PnOC1AShdPaF24h%2F0riFrxkQgbmRpJGVl25fDuHUNTZVz0d8hXYmkFgACFFynXVRWpEGmkyyFk2JaGMquguiyYfLHyXXkpkjJQpZqMPcEXyFJqtRseSoG7uHd87z%2FIx4%2Fiaf%2BkTjcdOt8qq6lH1yUspW3MitLJlxU7oHiWCfL6RfPWYrZnVpwjTTTqPpzhi33p6qclJXOYGLdw8PD4El84f6fPeXSMuJZVMTWktSxMidb3dHfWrQXiIyI4w1sHxG%2Bw2DsDp%2FiFS%2BRpxLW1kxx36VMT0h8YE4enf0kQvet9JNFnC1ZofMIwmuOIUXVHBOb705T%2F%2F%2FfbKdk5XhkSpgwo5XYZx8l27YWXEWhk743Jrg9oaDm0O4GnQ33pj9LngFLF4nk7yX6unXNdxhfH6Izvx2MkWNUuaIwxOnPbsfVrHZOhcYNX39uC1%2BQBHA0lmoNGB0Lhx0ZLxnrcJQQMowZp6UGQwzPfFqAY64gKKny2%2F2FZNUDw%2FmIRIjwre4XRWgi2XU89%2FGN1DQLU1L0ZEllQl6rVzjOI3jzDUDFklyKsHj7tuRzDQd3OWPZtGMeyWJ5FS5on0sOFRd9vmZIzEaX8BgQ0SbJybx2w6iK4JHCMuI1pg2q4iZ67lde1hEmLhbtXKaHD2jDIa87Wis5rm5KnTmBjIzI19eSDyq%2BVmsS0lc1eJxxpAauf6IccKRN512woJf9oHz0a5y5JfJzi2BqLamwGNWsXN6of86zJD9O1zHsSm1WGMf5FdSLXlDm2Dx6HAR6f8WcLjR4FtpOQG6VEKjIaRwEblRYrRYPEd6Ouz3wfg1%2BOEImuzcdgigAhYvTjZPoNyTpmNQEKGta3oNtQiokBTIKifhXa0%2FABbtbgSc0R1Pv1tmSSmn6X%2BWH6DW1pb8X1ZHt1AXqnLdUf1WVcb0VUY5jcNiqh%2FQE8eevdQJYJnoZo8AYS%2BRJcrpvs%3D&X-Amz-Signature=fef32b1f4ebdadc9850be68d58cb6a5b7273d8b46fb222decc5ea0186998fe8b&X-Amz-SignedHeaders=host",
    "attachmentsSheet": null,
    "rejectionReason": null,
    "clearanceRejectionReason": null,
    "prodFileRejectionReason": null,
    "viewerHash": "566852a54db7c861196040f796feb65f61785ae95f7c4375c47685d3387de459c093f7fcad6799de82fe402a65b5e911d1c85b8c8cbf19dcff72e9dd9379d4a14650c655f6112840f464efd888873dc8f25760466aee8dfbc4abb7f77d2f856e4f19c1a041c1d473b124eca91f647f4576879bfdac7cf8db779ea4a49e48d6e17cad47622efbe5c6116b84aac379c102e184f12677905d1ea8f124bdb0c8236c655fa1160899e6530069354c481919112176552a1512c872e6abb830fe2ff811",
    "notes": "Treatment Setup Notes (Visible to Doctor)\n",
    "otpFileUrl": null,
    "qcNotes": "Notes for QC\n",
    "retainers": 0,
    "prodFile": "",
    "status": "CONVERTED",
    "upperOvercorrectionSteps": 0,
    "lowerOvercorrectionSteps": 0,
    "upperTemplates": null,
    "lowerTemplates": null,
    "missingTeeth": {},
    "movementTable": [
        {
            "Tooth number": "16",
            "Rotation": "",
            "Angulation": "-3.00 deg",
            "Inclination": "",
            "Left/ Right": "0.30 mm",
            "Extrusion/ Intrusion": "",
            "Forward/ Backward": "0.60 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "83.1 deg",
            "Circumference": "34.8 mm"
        },
        {
            "Tooth number": "14",
            "Rotation": "11.00 deg",
            "Angulation": "-2.00 deg",
            "Inclination": "",
            "Left/ Right": "-0.03 mm",
            "Extrusion/ Intrusion": "",
            "Forward/ Backward": "0.30 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "84.6 deg",
            "Circumference": "25.3 mm"
        },
        {
            "Tooth number": "13",
            "Rotation": "11.00 deg",
            "Angulation": "-8.00 deg",
            "Inclination": "",
            "Left/ Right": "0.36 mm",
            "Extrusion/ Intrusion": "-0.10 mm",
            "Forward/ Backward": "0.13 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "67.4 deg",
            "Circumference": "22.1 mm"
        },
        {
            "Tooth number": "12",
            "Rotation": "-13.06 deg",
            "Angulation": "-3.55 deg",
            "Inclination": "-1.37 deg",
            "Left/ Right": "-0.72 mm",
            "Extrusion/ Intrusion": "-0.28 mm",
            "Forward/ Backward": "-0.50 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "60.3 deg",
            "Circumference": "20.6 mm"
        },
        {
            "Tooth number": "11",
            "Rotation": "19.00 deg",
            "Angulation": "-3.00 deg",
            "Inclination": "",
            "Left/ Right": "1.25 mm",
            "Extrusion/ Intrusion": "-0.09 mm",
            "Forward/ Backward": "-1.80 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "58.4 deg",
            "Circumference": "23.3 mm"
        },
        {
            "Tooth number": "21",
            "Rotation": "2.00 deg",
            "Angulation": "-4.00 deg",
            "Inclination": "4.00 deg",
            "Left/ Right": "0.46 mm",
            "Extrusion/ Intrusion": "-0.50 mm",
            "Forward/ Backward": "-1.43 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "60.5 deg",
            "Circumference": "23.7 mm"
        },
        {
            "Tooth number": "22",
            "Rotation": "-18.98 deg",
            "Angulation": "-5.80 deg",
            "Inclination": "1.62 deg",
            "Left/ Right": "-0.27 mm",
            "Extrusion/ Intrusion": "0.03 mm",
            "Forward/ Backward": "-1.44 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "59.5 deg",
            "Circumference": "19.0 mm"
        },
        {
            "Tooth number": "23",
            "Rotation": "9.00 deg",
            "Angulation": "-11.00 deg",
            "Inclination": "6.00 deg",
            "Left/ Right": "0.73 mm",
            "Extrusion/ Intrusion": "-0.49 mm",
            "Forward/ Backward": "-0.85 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "61.2 deg",
            "Circumference": "22.0 mm"
        },
        {
            "Tooth number": "24",
            "Rotation": "11.00 deg",
            "Angulation": "-9.00 deg",
            "Inclination": "",
            "Left/ Right": "0.75 mm",
            "Extrusion/ Intrusion": "",
            "Forward/ Backward": "0.40 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "79.6 deg",
            "Circumference": "25.6 mm"
        },
        {
            "Tooth number": "26",
            "Rotation": "",
            "Angulation": "-5.00 deg",
            "Inclination": "",
            "Left/ Right": "0.57 mm",
            "Extrusion/ Intrusion": "",
            "Forward/ Backward": "0.60 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "85.8 deg",
            "Circumference": "34.6 mm"
        },
        {
            "Tooth number": "36",
            "Rotation": "-4.00 deg",
            "Angulation": "",
            "Inclination": "2.00 deg",
            "Left/ Right": "",
            "Extrusion/ Intrusion": "0.20 mm",
            "Forward/ Backward": "0.60 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "84.2 deg",
            "Circumference": "33.6 mm"
        },
        {
            "Tooth number": "34",
            "Rotation": "-5.29 deg",
            "Angulation": "-2.00 deg",
            "Inclination": "4.00 deg",
            "Left/ Right": "0.08 mm",
            "Extrusion/ Intrusion": "",
            "Forward/ Backward": "0.50 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "75.6 deg",
            "Circumference": "21.6 mm"
        },
        {
            "Tooth number": "33",
            "Rotation": "-13.00 deg",
            "Angulation": "-1.00 deg",
            "Inclination": "9.00 deg",
            "Left/ Right": "0.20 mm",
            "Extrusion/ Intrusion": "0.90 mm",
            "Forward/ Backward": "-0.10 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "72.1 deg",
            "Circumference": "18.9 mm"
        },
        {
            "Tooth number": "32",
            "Rotation": "-2.00 deg",
            "Angulation": "",
            "Inclination": "3.00 deg",
            "Left/ Right": "-0.20 mm",
            "Extrusion/ Intrusion": "1.30 mm",
            "Forward/ Backward": "-0.60 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "61.5 deg",
            "Circumference": "17.5 mm"
        },
        {
            "Tooth number": "31",
            "Rotation": "4.00 deg",
            "Angulation": "-2.00 deg",
            "Inclination": "",
            "Left/ Right": "0.30 mm",
            "Extrusion/ Intrusion": "1.00 mm",
            "Forward/ Backward": "",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "59.5 deg",
            "Circumference": "16.8 mm"
        },
        {
            "Tooth number": "41",
            "Rotation": "3.00 deg",
            "Angulation": "2.00 deg",
            "Inclination": "2.00 deg",
            "Left/ Right": "-0.34 mm",
            "Extrusion/ Intrusion": "1.30 mm",
            "Forward/ Backward": "-0.30 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "59.5 deg",
            "Circumference": "16.6 mm"
        },
        {
            "Tooth number": "42",
            "Rotation": "5.09 deg",
            "Angulation": "4.00 deg",
            "Inclination": "2.00 deg",
            "Left/ Right": "-0.80 mm",
            "Extrusion/ Intrusion": "1.10 mm",
            "Forward/ Backward": "-0.40 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "60.6 deg",
            "Circumference": "17.2 mm"
        },
        {
            "Tooth number": "43",
            "Rotation": "-8.00 deg",
            "Angulation": "",
            "Inclination": "4.00 deg",
            "Left/ Right": "",
            "Extrusion/ Intrusion": "0.80 mm",
            "Forward/ Backward": "1.00 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "71.9 deg",
            "Circumference": "18.8 mm"
        },
        {
            "Tooth number": "44",
            "Rotation": "-4.04 deg",
            "Angulation": "",
            "Inclination": "2.00 deg",
            "Left/ Right": "-0.20 mm",
            "Extrusion/ Intrusion": "",
            "Forward/ Backward": "0.80 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "72.9 deg",
            "Circumference": "21.8 mm"
        },
        {
            "Tooth number": "46",
            "Rotation": "",
            "Angulation": "1.00 deg",
            "Inclination": "2.00 deg",
            "Left/ Right": "-0.10 mm",
            "Extrusion/ Intrusion": "0.20 mm",
            "Forward/ Backward": "0.50 mm",
            "IPR Distal": "",
            "IPR Mesial": "",
            "Long Axis": "85.9 deg",
            "Circumference": "33.1 mm"
        }
    ],
    "movementTableUrl": "https://eon-manufacturing-dev.s3.eu-central-1.amazonaws.com/public/705/732/1690216116153_movement_table.html?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA2DDTJHHC534KVVMA%2F20230925%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20230925T130346Z&X-Amz-Expires=604800&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEGQaDGV1LWNlbnRyYWwtMSJHMEUCIGpq%2Fq%2FVpG2TxEd7Y8h2qS58v5XZN1IDHLIm4aZoliSsAiEAyTGddT9hPxp0SBmUAgYotTxX0VP0jrsl1x%2FiQ8Tjoa0qygUIXhADGgw2OTM4Nzg5OTUzOTciDPO2lB6%2FQNN5mwTb4SqnBXnAffGEOYSaCVFBB4KTc00hJxzOQbKYAEuPt5yMSPMvrXhnfWYu5iaUtxqwBsE0Xifu3xJCdv8hHD%2BC4kUc6OQAVJtNAeimR755h8uVUo%2Bwi%2BAK0OQ%2BaFADtCfu0iASfpXeyI3w%2BgadpxLDlI%2BAd%2F4cEPM9ehx%2B15TnIwgW0%2BrLyoYeOZyXP52G8aYG0ZPCEOFkvv6xH8L64uylwRCkS3Z01DmnYkN0uF1p1dzW3NCuF0N1pWjYaCdZQqW4HLN609eVsrT10fSAopV8TEV7gkbUaKRVMbRimrlQPRborwsR6YKjjm7dD0r51xo13FfEzVfLxz%2FWrCZeXZ5GQEjScNnLWG8oA6iqGC2rMxadRymt3u2qG92guVHTqI4pzrEAYvZfX47M%2FXIUJ8%2BhZu8rSQYCw1WdcZ8a3OcTZhmF0VeannrY5PnOC1AShdPaF24h%2F0riFrxkQgbmRpJGVl25fDuHUNTZVz0d8hXYmkFgACFFynXVRWpEGmkyyFk2JaGMquguiyYfLHyXXkpkjJQpZqMPcEXyFJqtRseSoG7uHd87z%2FIx4%2Fiaf%2BkTjcdOt8qq6lH1yUspW3MitLJlxU7oHiWCfL6RfPWYrZnVpwjTTTqPpzhi33p6qclJXOYGLdw8PD4El84f6fPeXSMuJZVMTWktSxMidb3dHfWrQXiIyI4w1sHxG%2Bw2DsDp%2FiFS%2BRpxLW1kxx36VMT0h8YE4enf0kQvet9JNFnC1ZofMIwmuOIUXVHBOb705T%2F%2F%2FfbKdk5XhkSpgwo5XYZx8l27YWXEWhk743Jrg9oaDm0O4GnQ33pj9LngFLF4nk7yX6unXNdxhfH6Izvx2MkWNUuaIwxOnPbsfVrHZOhcYNX39uC1%2BQBHA0lmoNGB0Lhx0ZLxnrcJQQMowZp6UGQwzPfFqAY64gKKny2%2F2FZNUDw%2FmIRIjwre4XRWgi2XU89%2FGN1DQLU1L0ZEllQl6rVzjOI3jzDUDFklyKsHj7tuRzDQd3OWPZtGMeyWJ5FS5on0sOFRd9vmZIzEaX8BgQ0SbJybx2w6iK4JHCMuI1pg2q4iZ67lde1hEmLhbtXKaHD2jDIa87Wis5rm5KnTmBjIzI19eSDyq%2BVmsS0lc1eJxxpAauf6IccKRN512woJf9oHz0a5y5JfJzi2BqLamwGNWsXN6of86zJD9O1zHsSm1WGMf5FdSLXlDm2Dx6HAR6f8WcLjR4FtpOQG6VEKjIaRwEblRYrRYPEd6Ouz3wfg1%2BOEImuzcdgigAhYvTjZPoNyTpmNQEKGta3oNtQiokBTIKifhXa0%2FABbtbgSc0R1Pv1tmSSmn6X%2BWH6DW1pb8X1ZHt1AXqnLdUf1WVcb0VUY5jcNiqh%2FQE8eevdQJYJnoZo8AYS%2BRJcrpvs%3D&X-Amz-Signature=7e89596098dd1c1df84024714c443a60e9983eb80361ef6e6950338a24b5164b&X-Amz-SignedHeaders=host",
    "advancedModules": {
        "modules": [
            {
                "id": 1,
                "key": "extraction",
                "inner_title_key": "extraction",
                "dataKey": "extraction",
                "title": "Extraction",
                "active": false
            },
            {
                "id": 2,
                "key": "ipr",
                "inner_title_key": "ipr_short",
                "dataKey": "ipr",
                "title": "Interproximal reduction",
                "active": true
            },
            {
                "id": 3,
                "key": "attachments",
                "inner_title_key": "attachments",
                "dataKey": "attachments",
                "title": "Attachments",
                "active": true
            },
            {
                "id": 4,
                "key": "pontics",
                "inner_title_key": "pontics",
                "dataKey": "pontics",
                "title": "Pontics",
                "active": false
            },
            {
                "id": 5,
                "key": "passive_aligners",
                "inner_title_key": "passive_aligners",
                "dataKey": "passiveAligners",
                "title": "Passive Aligner",
                "active": false
            },
            {
                "id": 6,
                "key": "tooth_size_discrepancy",
                "inner_title_key": "tooth_size_discrepancy",
                "dataKey": "toothSizeDiscrepancy",
                "title": "Tooth size Discrepancy",
                "active": false
            },
            {
                "id": 7,
                "key": "torque_enhancers",
                "inner_title_key": "torque_enhancers",
                "dataKey": "torqueEnhancers",
                "title": "Torque Enhancers",
                "active": false
            },
            {
                "id": 8,
                "key": "bite_ramps",
                "inner_title_key": "bite_ramps",
                "dataKey": "biteRamps",
                "title": "Bite Ramps",
                "active": false
            },
            {
                "id": 9,
                "key": "elastics",
                "inner_title_key": "elastics",
                "dataKey": "elastics",
                "title": "Elastics",
                "active": false
            },
            {
                "id": 10,
                "key": "teeth_movement",
                "inner_title_key": "teeth_movement",
                "dataKey": "teethMovement",
                "title": "Tooth movement rate",
                "active": false
            }
        ],
        "tooth_size_discrepancy": {
            "useModule": false,
            "options": {}
        },
        "torque_enhancers": {
            "useModule": false,
            "options": {}
        },
        "arch_expansion": {
            "useModule": false,
            "options": {}
        },
        "ap_discrepancies": {
            "useModule": false,
            "options": {}
        },
        "spacing": {
            "useModule": false,
            "options": {}
        },
        "vertical": {
            "useModule": false,
            "options": {}
        },
        "transverse": {
            "useModule": false,
            "options": {}
        },
        "elastics": {
            "useModule": false,
            "options": {}
        },
        "extraction": {
            "useModule": false,
            "options": {}
        },
        "ipr": {
            "useModule": true,
            "options": {
                "iprPosition": {
                    "21": {
                        "2": "0.2"
                    }
                }
            }
        },
        "attachments": {
            "useModule": true,
            "options": {
                "teeth": {
                    "0": {
                        "buccal": "2"
                    }
                }
            }
        },
        "pontics": {
            "useModule": false,
            "options": {}
        },
        "overCorrection": {
            "useModule": false,
            "options": {}
        },
        "bite_ramps": {
            "useModule": false,
            "options": {}
        },
        "teeth_movement": {
            "useModule": false,
            "options": {}
        },
        "passive_aligners": {
            "useModule": false,
            "options": {}
        }
    },
    "manufacturingNotes": "Manufacturing Notes\n",
    "publishedAt": null,
    "approvedAt": null,
    "clearedAt": null,
    "clientApprovedAt": null,
    "requestId": "732",
    "overcorrection": false,
    "hasPassiveAligners": false,
    "hasAttachments": false,
    "isSyncing": false,
    "convertedFilesUrl": null,
    "reconverting": false,
    "rawFileKey": null,
    "createdAt": "2023-07-24T16:29:07.453Z",
    "updatedAt": "2023-08-30T16:06:59.482Z",
    "deletedAt": null,
    "revision": 1,
    "flags": {
        "overcorrection": false,
        "hasPassiveAligners": false,
        "hasAttachments": false,
        "isSyncing": false
    }
}